import React, { memo } from 'react'

import usePrivateModeChange from 'Pods/ThreeDStudio/Hooks/usePrivateModeChange'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import PaidFeatureBadge from 'Pods/ThreeDStudio/Shared/PaidFeatureBadge/PaidFeatureBadge'
import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { setIsPrivate } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

function PrivateModeSelector() {
  const t = useTranslation()
  const { hasPrivateModeAccess, handlePrivateChange } = usePrivateModeChange('private_mode', setIsPrivate)

  // This selector is SSR-rendered on a fast page, so the paid variant must derive
  // from the access tier alone. The tier is null in the shared SSR store and only
  // hydrates from /load-services.js after mount, so it is null both server-side and
  // on the client's first (hydration) render - keeping the tree identical across
  // that boundary. Gating on isLoggedIn (pageConfig) instead would swap the
  // click handler on the first client render once pageConfig resolves, tripping a
  // React 18 hydration mismatch. Subscribed/credit users briefly see the crown and
  // it collapses once their tier resolves - the accepted per-user cost.
  const showPaidVariant = !hasPrivateModeAccess

  // Paid variant keeps the toggle interactive (not disabled): clicking it opens the
  // subscription modal instead of flipping isPrivate, so the switch stays visually
  // off while the user sees the upsell.
  return (
    <ToggleSelector
      id="private-mode-selector"
      keyName="isPrivate"
      sliceName="modelSettings"
      label={t('shared.privateMode.label')}
      setFunction={handlePrivateChange}
      tooltipMessage={t('shared.privateMode.tooltip')}
      badge={showPaidVariant ? <PaidFeatureBadge label={t('shared.subscribersOnly.title')} /> : null}
    />
  )
}

export default memo(PrivateModeSelector)
